import React from 'react';
import { splitHighlightParts } from '@/utils/helpDocs';

interface HighlightedTextProps {
  text: string;
  query?: string;
}

/** Renders text with case-insensitive query matches wrapped in <mark>. */
const HighlightedText: React.FC<HighlightedTextProps> = ({ text, query }) => {
  const trimmed = query?.trim() ?? '';
  if (!trimmed) {
    return <>{text}</>;
  }

  return (
    <>
      {splitHighlightParts(text, trimmed).map((part, index) =>
        part.match ? (
          <mark key={index} className="help-page__search-mark">
            {part.text}
          </mark>
        ) : (
          <React.Fragment key={index}>{part.text}</React.Fragment>
        )
      )}
    </>
  );
};

export default HighlightedText;
